export default __webpack_public_path__ + "static/media/a012-4.a4c3f24a.svg";